import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/Ministry.module.css";
import heroImg from "../assets/images/image12.png";
import img1 from "../assets/images/abarinzi.png";
import img2 from "../assets/images/image8.png";
import img3 from "../assets/images/usher.png";
import img4 from "../assets/images/media.png";
import img5 from "../assets/images/interpretation.png";
import img6 from "../assets/images/media.png";
import img7 from "../assets/images/image12.png";
import youthImg from "../assets/images/image7.png";
import womenImg from "../assets/images/MamaMiriam.png";
import menImg from "../assets/images/image1.png";
import getInvolvedBg from "../assets/images/image7.png";

function useInView(ref, { threshold = 0.1, once = true } = {}) {
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          if (once) obs.disconnect();
        }
      },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return visible;
}

const MINISTRIES = [
  { id: 1,  tag: "Prayer",     title: "Intercession Team",      desc: "Dedicated prayer warriors interceding for the church, community, and world.",                         image: img1 },
  { id: 2,  tag: "Worship",    title: "Worship Team",           desc: "Lead worship with music and create an atmosphere of praise and the glory of God.",                    image: img2 },
  { id: 3,  tag: "Service",    title: "Ushers & Hospitality",   desc: "Welcome visitors with warmth and excellence as the living first impression of CWFM.",                 image: img3 },
  { id: 4,  tag: "Media",      title: "Media & Production",     desc: "Manage live streaming, video production, graphics, and all technical operations.",                    image: img4 },
  { id: 5,  tag: "Language",   title: "Interpretation Dept.",   desc: "Bridge language barriers so every person can receive God\'s Word in their own tongue.",              image: img5 },
  { id: 6,  tag: "Technology", title: "IT & Technology",        desc: "Support our digital infrastructure, website, apps, and secure online systems.",                      image: img6 },
  { id: 7,  tag: "Children",   title: "Kids Ministry",          desc: "Shape young lives through Bible teaching, creative activities, and loving mentorship.",               image: img7 },
  { id: 8,  tag: "Youth",      title: "Youth Ministry",         desc: "Disciple teenagers and young adults through relevant Bible studies and leadership programs.",         image: youthImg },
  { id: 9,  tag: "Women",      title: "Women\'s Ministry",     desc: "Empower women of all ages through Bible studies, prayer groups, and mentorship programs.",            image: womenImg },
  { id: 10, tag: "Men",        title: "Men\'s Ministry",       desc: "Equip men to be spiritual leaders through discipleship, accountability, and fellowship.",             image: menImg },
];

export default function Ministry() {
  const navigate = useNavigate();
  const gridRef = useRef(null);
  const ctaRef  = useRef(null);
  const gridVisible = useInView(gridRef, { threshold: 0.05 });
  const ctaVisible  = useInView(ctaRef,  { threshold: 0.15 });

  const handleScrollDown = () => {
    window.scrollTo({ top: window.innerHeight, behavior: "smooth" });
  };

  return (
    <div className={styles.ministryPage}>

      {/* ── Cinematic Hero ── */}
      <section className={styles.hero}>
        <img src={heroImg} alt="Our Ministries" className={styles.heroImg} />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <span className={styles.eyebrow}>CWFM · Departments</span>
          <h1 className={styles.heroTitle}>Our Ministries</h1>
          <div className={styles.titleBar} />
          <p className={styles.heroSub}>
            Discover the many ways we serve God and our community through
            faith, fellowship, and active service at Calvary Wide Fellowship Ministries.
          </p>
        </div>
        <button
          className={styles.scrollCue}
          onClick={handleScrollDown}
          aria-label="Scroll down"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
      </section>

      {/* ── Ministry Grid ── */}
      <section className={styles.gridOuter}>
        <div className={styles.gridSection}>
        <div className={styles.sectionHead}>
          <span className={styles.gridEyebrow}>Find Your Place</span>
          <h2 className={styles.gridTitle}>Ways to Serve</h2>
          <p className={styles.gridDesc}>
            Whether you are passionate about prayer, worship, hospitality, technology,
            or working with specific age groups — there is a place for you here.
          </p>
        </div>

        <div
          ref={gridRef}
          className={`${styles.ministryGrid} ${gridVisible ? styles.gridVisible : ""}`}
        >
          {MINISTRIES.map((m, i) => (
            <div
              key={m.id}
              className={styles.ministryCard}
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <img src={m.image} alt={m.title} className={styles.cardBg} />
              <div className={styles.cardGrad} />
              <div className={styles.cardContent}>
                <span className={styles.cardTag}>{m.tag}</span>
                <div className={styles.cardBottom}>
                  <h3 className={styles.cardTitle}>{m.title}</h3>
                  <p className={styles.cardDesc}>{m.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        </div>
      </section>

      {/* ── Get Involved CTA ── */}
      <section
        ref={ctaRef}
        className={`${styles.ctaSection} ${ctaVisible ? styles.ctaVisible : ""}`}
        style={{ backgroundImage: `url(${getInvolvedBg})` }}
      >
        <div className={styles.ctaOverlay} />
        <div className={styles.ctaContent}>
          <span className={styles.ctaEyebrow}>Ready to Serve?</span>
          <h2 className={styles.ctaTitle}>Get Involved</h2>
          <div className={styles.ctaTitleBar} />
          <p className={styles.ctaDesc}>
            Connect with a ministry team that aligns with your passions and spiritual
            gifts. We would love to have you join our community of dedicated believers.
          </p>
          <a
            href="/membership"
            className={styles.ctaButton}
            onClick={(e) => { e.preventDefault(); navigate("/membership"); }}
          >
            Join a Ministry
          </a>
        </div>
      </section>

    </div>
  );
}
